import React from 'react';
import './components.css';
import eventImg from './img/kids.jpg';

const events = [
  {
    img: eventImg,
    alt: 'Puzzle Night at The Happy Book Stack',
    date: 'May 2 · 6 PM - 8 PM',
    title: 'Puzzle Night',
    desc: 'Bring a friend, settle in, and spend the evening puzzling with us at the shop.',
    link: 'https://l.instagram.com/?u=https%3A%2F%2Fsquare.link%2Fu%2FkhdI4kXq%3Futm_source%3Dig%26utm_medium%3Dsocial%26utm_content%3Dlink_in_bio%26fbclid%3DPAZXh0bgNhZW0CMTEAc3J0YwZhcHBfaWQMMjU2MjgxMDQwNTU4AAGnIQZHKpPVaab_q3pKHTlzYoiYPVbCbNeTIN1M6bAnZah89xLsylwY1NWH6LQ_aem_oaqyHU8x2T4HCxdXqnXgdw&e=AT4S3dIEkwgptUv1ASkFT8jF5KEOKQLwlIGYGOE9_dM2OYt0mt8l8gr-MQzLtflT2_J8yPTm-QGO6Jroy4_U9Folwf84URcNcZICgi0W6w',
    cta: 'Reserve a spot',
  },
];

function Calendar() {
  return (
    <section className="calendar" id="calendar">
      <div className="section-head">
        <span className="kicker">03 — On The Calendar</span>
        <h2 className="section-title">Upcoming gatherings</h2>
        <p className="section-lede">
          One upcoming in-store event for now, with more to come.
        </p>
      </div>

      <div className={`event-grid ${events.length === 1 ? 'event-grid--single' : ''}`.trim()}>
        {events.map((e) => (
          <article className="event-card" key={e.title}>
            <img src={e.img} alt={e.alt} className="event-image" />
            <div className="event-body">
              <p className="event-date">{e.date}</p>
              <h3 className="event-title">{e.title}</h3>
              <p className="event-desc">{e.desc}</p>
              <a className="event-link" href={e.link} target="_blank" rel="noreferrer">
                {e.cta}
              </a>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}

export default Calendar;
